import styled from 'styled-components';
import { media } from 'theme';

export const PageContent = styled.div`
  width: 904px;
  padding: 23px 35px;
  background: white;
  margin: 0 auto;
  border-radius: 4px;

  ${media.largeAndDown`
    width: 100%;
    padding: 23px 25px;
  `}
`;

export const Text = styled.div`
  * {
    margin-bottom: 20px;
  }

  h2 {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    color: ${props => props.theme.colors.neutral7};
    margin-bottom: 20px;
    margin-top: 45px;

    ${media.smallAndUp`
      font-size: 24px;
    `}
  }

  h2:first-child {
    margin-top: 5px;
  }

  h3 {
    margin-bottom: 0px;
  }

  img {
    max-width: 100%;
    width: 100%;
    margin: 0;

    ${media.ie`
      flex: none;
    `}
  }

  ul > li {
    list-style-type: circle;
    margin-bottom: 0;
  }

  ol > li {
    list-style-type: decimal;
    margin-bottom: 0;
  }

  ul {
    margin-bottom: 0;
  }

  li {
    margin-left: 30px;
    padding-bottom: 3px;
  }

  a:link {
    color: ${props => props.theme.colors.seedlyBlue};
  }

  a:visited {
    color: ${props => props.theme.colors.seedlyBlue};
  }
`;

export const Investors = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: center;
  width: 100%;
  margin-bottom: 36px;

  h2 {
    font-size: 18px;
    font-weight: 700;
    text-align: center;
    color: ${props => props.theme.colors.neutral7};
    margin-bottom: 25px;
    margin-top: 25px;
    display: inline;

    ${media.smallAndUp`
      font-size: 24px;
    `}
  }

  ${media.smallAndUp`
    flex-direction: row;
    `}
`;

export const Investor = styled.img`
  display: flex;
  margin: 10px 10px 20px 10px;
  max-height: 60px;
  height: 100%;
  width: auto;
  align-self: center;
  text-align: center;

  &:last-child {
    margin-bottom: 10px;
  }

  ${media.smallAndUp`
    max-width: 180px;
    max-height: none;
    width: 100%;
    height: auto;
    margin: 10px;
    `}
`;
